
export const SOCIAL_LEADS_ROLES = ["v3","admin",];

export const SOCIAL_LEADS_OVERSIGHT_ROLES = ["v3","admin"];

export const canSeeSocialLeads = (role) => SOCIAL_LEADS_ROLES.includes(role);
